export class TypedEventEmitter {
    constructor(options) {
        this.listeners = new Map();
        this.emitterDebug = options?.debug ?? false;
    }
    on(event, listener) {
        let set = this.listeners.get(event);
        if (!set) {
            set = new Set();
            this.listeners.set(event, set);
        }
        const fn = listener;
        set.add(fn);
        return () => {
            set.delete(fn);
            if (set.size === 0)
                this.listeners.delete(event);
        };
    }
    off(event, listener) {
        const set = this.listeners.get(event);
        if (!set)
            return;
        set.delete(listener);
        if (set.size === 0)
            this.listeners.delete(event);
    }
    emit(event, data) {
        const set = this.listeners.get(event);
        if (!set)
            return;
        for (const listener of set) {
            try {
                listener(data);
            }
            catch (err) {
                if (this.emitterDebug)
                    console.error('[EventEmitter] Listener error:', err);
            }
        }
    }
    once(event, listener) {
        const unsub = this.on(event, (data) => {
            unsub();
            listener(data);
        });
        return unsub;
    }
    removeAllListeners() {
        this.listeners.clear();
    }
}
